<template>
  <div style="overflow: hidden;">
    <headers :title="title+'实时运行数据'"></headers>
    <div class="fiveLeft">
      <div class="minbox" v-for="(item,index) in inOutlist" :key="index">
        <p>{{item.title}}</p>
        <span>{{item.num}}</span>
      </div>
    </div>
    <div class="box">
      <div class="alltitle">今日与昨日进馆人数对比</div>
      <div class="echartLine" id="echart-line"></div>
    </div>
    <div class="box">
      <div class="alltitle">今年客流最多的工作周排名</div>
      <div class="echartLine" id="myChart"></div>
    </div>
    <div class="box">
      <div class="alltitle">上月客流最多的工作日排名</div>
      <div class="echartLine" id="pieChart"></div>
    </div>
    <div class="box">
            <!-- <div class="alltitle">近30天高峰客流时段 _this.lineChart2() 菏泽图书馆 展示与其他不一致</div> -->
       <div class="alltitle">近30天高峰客流时段</div>
      <!-- <div class="alltitle">读书推荐</div> -->
      <div class="echartLine" id="echart-line2" style=" overflow: hidden;">

       <!-- <vue-seamless-scroll :data="bookRankingList" :class-option="classOption">
           <template v-for="(book,index) in bookRankingList">
           <div :key="index">{{book.biblios.title}}{{book.biblios.author}}{{book.biblios.publisher}}</div>
          </template>
       </vue-seamless-scroll> -->

          <table class="table1" width="100%" border="0" cellspacing="0" v-if="0==1" cellpadding="0">
                <tbody>
                  <tr>
                    <th style="width:33.3%">书名</th>
                    <th style="width:33.3%">作者</th>
                    <th style="width:33.3%">出版社</th>
                  </tr>
                </tbody>
          </table>
         <table class="table1" width="100%" border="0"  v-if="0==1" cellspacing="0" cellpadding="0">
				  <tbody>
				 
          <vue-seamless-scroll :data="bookRankingList" :class-option="classOption">
				    <tr v-for="(book,index) in bookRankingList" :key="index">
				      <td style="width:33.3%">{{book.biblios.title}}</td>
				      <td style="width:33.3%">{{book.biblios.author}}</td>
				      <td style="width:33.3%">{{book.biblios.publisher}}</td>
				    </tr>
				 </vue-seamless-scroll>
				  </tbody>
				</table>
        
      </div>
    </div>
  </div>
</template>

<script>
import {formatDate,getPreMonth}  from '@/utils/date.js'
  import {
  getDayEntityHourData,
  getDayEntityData,
  getEntityWeekData,
  getEntityMonthData,
  getLowEntityMonthData,
  getEntityQuarterData,
  getEntityYearData,
  getEntityAllYearData} from '@/api/anjisheng';
  import {getBookRanking } from "@/api/study"
  const echarts = require('echarts');
  import headers from './headers.vue'
  export default{
    components:{
      headers
    },
    computed:{
       classOption() {
        return {
          step: 0.1, // 数值越大速度滚动越快
          limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
          hoverStop: true, // 是否开启鼠标悬停stop
          direction: 1, // 0向下 1向上 2向左 3向右
          openWatch: true, // 开启数据实时监控刷新dom
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
        }
      }
    },

    data(){
      return{
        inOutlist:[
          {title:'今日进馆 ',num:'0'},
          {title:'今日出馆',num:'90'},
          {title:'在馆人数 ',num:'5890'},
          {title:'本周统计 ',num:'11890'},
          {title:'本月统计 ',num:'890'},
          {title:'季度统计 ',num:'50290'},
          {title:'年度统计 ',num:'890'},
          {title:'累计人数 ',num:'1112890'}
        ],
          xLineData: ['0','1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18',
            '19', '20','21','22','23'
          ],


         day30Info: [130, 200, 250, 200, 150, 180, 200, 250, 300, 100, 150, 120, 180, 240, 300, 340, 350, 200, 500,
            400
          ],

          yLineDataOne: [130, 200, 250, 200, 150, 180, 200, 250, 300, 100, 150, 120, 180, 240, 300, 340, 350, 200, 500,
            400
          ],
          yLineDataTwo: [30, 100, 150, 100, 50, 80, 100, 150, 200, 0, 50, 20, 80, 140, 200, 240, 250, 100, 400, 300],
          xData: ['第5周', '第9周', '第15周', '第21周', '第26周', '第35周'],
          yData: [20, 90, 65, 45, 60, 140, 190],
          title:'',
          xLow30Data: ['1', '2', '3', '4', '5', '6', '7'], 
          dayLow30Info: [150, 230, 224, 218, 135, 147, 260],
          bookRankingList:[],
      }
    },
    created() {
      var libraryInfo = JSON.parse(sessionStorage.getItem("libraryInfo"));
      var _this = this;
      _this.title = libraryInfo.name;
    },
    mounted() {

     this.timers = setInterval(() => {
        this.getDayEntityData()
         this.pieChartFun()
             
      }, 5*60*1000);

     this.getDayEntityData()

      this.pieChartFun()
      this. getBookRanking();
    },
    methods:{

     getBookRanking(){
       getBookRanking(30).then(response => {
         
           this.bookRankingList =response.data.returnList;
           console.log(  this.bookRankingList)
       })
     },

      getDayEntityData(){
        var libraryInfo = JSON.parse(sessionStorage.getItem("libraryInfo"));
             var _this =this;
                getDayEntityData(libraryInfo.entityId).then(response => {

                     var inOutlist = _this.inOutlist;
                     inOutlist.splice(0, 1,  {title:'今日进馆',num:''+response.Data[0].DataIn});
                     inOutlist.splice(1, 1,  {title:'今日出馆',num:''+response.Data[0].DataOut});
                     var dataIn = response.Data[0].DataIn-response.Data[0].DataOut;
                     if (dataIn<0) {
                      dataIn = 0;
                     }
                     inOutlist.splice(2, 1,  {title:'在馆人数',num:''+dataIn});

                     _this.inOutlist = inOutlist;

                  }).catch(error => {
                        console.log(error);
                  });

              getEntityWeekData(libraryInfo.entityId).then(response => {
                  var inOutlist = _this.inOutlist;
                   inOutlist.splice(3, 1,  {title:'本周统计 ',num: response.Data[response.Count-1].DataIn});
                  _this.inOutlist = inOutlist;
              })

            getEntityMonthData(libraryInfo.entityId).then(response => {
                  var inOutlist = _this.inOutlist;
                   inOutlist.splice(4, 1,  {title:'本月统计 ',num: response.Data[response.Count-1].DataIn});
                  _this.inOutlist = inOutlist;
              })

            getEntityQuarterData(libraryInfo.entityId).then(response => {
                  var inOutlist = _this.inOutlist;
                   inOutlist.splice(5, 1,  {title:'季度统计 ',num: response.Data[response.Count-1].DataIn});
                  _this.inOutlist = inOutlist;
              })

             getEntityYearData(libraryInfo.entityId).then(response => {
                  var inOutlist = _this.inOutlist;

                   inOutlist.splice(6, 1,  {title:'年度统计 ',num: response.Data[response.Count-1].DataIn});
                  _this.inOutlist = inOutlist;
              })

            getEntityAllYearData(libraryInfo.entityId).then(response => {
                  var inOutlist = _this.inOutlist;
                  var allIn=0;

                  for(var i=0;i< response.Data.length;i++){
                    allIn=allIn+response.Data[i].DataIn
                  }

                   inOutlist.splice(7, 1,  {title:'累计人数 ',num: allIn});
                  _this.inOutlist = inOutlist;
              })

            getDayEntityHourData(libraryInfo.entityId).then(response => {

                _this.yLineDataOne=[];
                for(var i=0;i<response.Data.length;i++){
                    _this.yLineDataOne.push(response.Data[i].DataIn);
                }
                var yeasDay = formatDate(new Date(new Date().getTime()-24*60*60*1000),"yyyy-MM-dd");

                 getDayEntityHourData(libraryInfo.entityId,yeasDay+" 00:00:00",yeasDay+" 23:59:59").then(response => {

                        _this.yLineDataTwo=[];
                        for(var i=0;i<response.Data.length;i++){
                            _this.yLineDataTwo.push(response.Data[i].DataIn);
                        }
                        _this.lineChart()
                 })

            })

             var year = formatDate(new Date(),"yyyy");
             getEntityWeekData(libraryInfo.entityId,year+"-01-01 00:00:00",formatDate(new Date(),"yyyy-MM-dd hh:mm:ss")).then(response => {
                      _this.yData=[];
                      _this.xData=[];
                        for(var i=0;i<response.Data.length;i++){
                            _this.yData.push(response.Data[i].DataIn);
                            _this.xData.push(response.Data[i].Name);

                        }
                      _this.histogram()
              })


             getDayEntityData(libraryInfo.entityId, formatDate(new Date(new Date().getTime()-30*24*60*60*1000),"yyyy-MM-dd")+" 00:00:00" ,formatDate(new Date(),"yyyy-MM-dd hh:mm:ss")).then(response => {


                     _this. xLineData=[];
                     _this. day30Info=[];
                      for(var i=0;i<response.Data.length;i++){
                            _this.day30Info.push(response.Data[i].DataIn);
                            _this.xLineData.push(response.Data[i].Name);
                        }

                    _this.lineChart2()
              }).catch(error => {
                    console.log(error);
              });

              getLowEntityMonthData(libraryInfo.entityId, null, null).then(response => {
                debugger
                     _this. xLow30Data=[];
                     _this. dayLow30Info=[];
                      for(var i=0;i<response.Data.length;i++){
                            _this.dayLow30Info.push(response.Data[i].DataIn);
                            _this.xLow30Data.push(response.Data[i].Name);
                        }
                      console.log("========================");
                      console.log(_this. xLow30Data);
                      console.log(_this. dayLow30Info);
                      
                     _this.pieChartFun()
              }).catch(error => {
                    console.log(error);
              });
      },
      lineChart() {
        let getchart = echarts.init(document.getElementById('echart-line'));
        var option = {
          color: ['#80FFA5', '#00DDFF'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: {
            data: ['今日', '昨日'],
            top: 40,
            right: 10,
            textStyle: { //图例文字的样式
              color: '#628EDB',
              fontSize: 16
            }
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          dataZoom: [{
            type: 'inside',
            start: 0,
            end: 74
          }],
          xAxis: [{
            type: 'category',
            boundaryGap: false,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#4E73B4'
              }
            },
            data: this.xLineData
          }],
          yAxis: [{
            type: 'value',
            name: '人数',
            splitLine: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#4E73B4'
              }
            },
          }],
          series: [{
              name: '今日',
              type: 'line',
              stack: '总量',
              smooth: true,
              lineStyle: {
                width: 0
              },
              showSymbol: false,
              areaStyle: {
                opacity: 0.8,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(128, 255, 165)'
                }, {
                  offset: 1,
                  color: 'rgba(1, 191, 236)'
                }])
              },
              emphasis: {
                focus: 'series'
              },
              data: this.yLineDataOne
            },
            {
              name: '昨日',
              type: 'line',
              stack: '总量',
              smooth: true,
              lineStyle: {
                width: 0
              },
              showSymbol: false,
              areaStyle: {
                opacity: 0.8,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(0, 221, 255)'
                }, {
                  offset: 1,
                  color: 'rgba(77, 119, 255)'
                }])
              },
              emphasis: {
                focus: 'series'
              },
              data: this.yLineDataTwo
            }
          ],
        };
        getchart.setOption(option);
        //随着屏幕大小调节图表
        window.addEventListener("resize", () => {
          getchart.resize();
        });
      },
      lineChart2() {
        let getchart = echarts.init(document.getElementById('echart-line2'));
        var option = {

          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          dataZoom: [{
            type: 'inside',
            start: 0,
            end: 100
          }],
          xAxis: [{
            type: 'category',
            boundaryGap: false,
            axisLine: {
              show: true,
              lineStyle: {
                color: '#4E73B4'
              }
            },
            data: this.xLineData
          }],
          yAxis: [{
            type: 'value',
            name: '人数',
            splitLine: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#4E73B4'
              }
            },
          }],
          series: [{
              name: '今日',
              type: 'line',
              stack: '总量',
              smooth: true,
              lineStyle: {
                width: 0
              },
              showSymbol: false,
              areaStyle: {
                opacity: 0.8,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(128, 255, 165)'
                }, {
                  offset: 1,
                  color: 'rgba(1, 191, 236)'
                }])
              },
              emphasis: {
                focus: 'series'
              },
              data: this.day30Info
            }

          ],
        };
        getchart.setOption(option);
        //随着屏幕大小调节图表
        window.addEventListener("resize", () => {
          getchart.resize();
        });
      },
      histogram(){
        let myChartDrawer = echarts.init(document.getElementById('myChart'))

                        // 绘制条形图
                        var option = {
                          title: {
                            text: name,
                            padding: [12, 0, 0, 15],
                            textStyle: {
                              color: '#ffffff'
                            }

                          },
                          tooltip: {
                            trigger: 'axis',
                            axisPointer: { // 坐标轴指示器，坐标轴触发有效
                              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
                            }
                          },
                          grid: {
                            left: '3%',
                            right: '4%',
                            bottom: '3%',
                            containLabel: true
                          },
                          xAxis: [{
                            type: 'category',
                            data: this.xData,
                            name: '时间',
                            axisTick: {
                              alignWithLabel: true
                            },
                            axisLine: {
                              show: true,
                              lineStyle: {
                                color: '#4E73B4'
                              }
                            },
                          }],
                          yAxis: [{
                            type: 'value',
                            splitLine: {
                              show: false
                            },
                            name: '人数',
                            position: 'left',
                            axisLine: {
                              show: true,
                              lineStyle: {
                                color: '#4E73B4'
                              }
                            },
                          }],
                          series: [{
                            type: 'bar',
                            barWidth: 22, //柱图宽度
                            itemStyle: {
                              normal: {
                                barBorderRadius: [11, 11, 0, 0],
                                color: {
                                  type: 'linear',
                                  x: 0,
                                  y: 0,
                                  x2: 0,
                                  y2: 1,
                                  colorStops: [{
                                    offset: 0,
                                    color: '#04CC95' // 0% 处的颜色
                                  }, {
                                    offset: 1,
                                    color: '#1F5DC4' // 100% 处的颜色
                                  }, {
                                    offset: 1,
                                    color: '#0F0B2E  ' // 100% 处的颜色
                                  }],
                                  globalCoord: true // 缺省为 false
                                },
                              },
                            },
                            data: this.yData

                          }]
                        };
                        myChartDrawer.setOption(option);
                        //随着屏幕大小调节图表
                        window.addEventListener("resize", () => {
                          myChartDrawer.resize();
                        });
      },
      pieChartFun(){
        var myChart = echarts.init(document.getElementById('pieChart'));
        // 绘制图表
        myChart.setOption({
            xAxis: {
                    type: 'category',
                    data: this.xLow30Data,
                    axisLine: {
                      show: true,
                      lineStyle: {
                        color: '#ffffff'
                      }
                    },
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                      show: true,
                      lineStyle: {
                        color: '#ffffff'
                      }
                    },
                },
                series: [{
                    data: this.dayLow30Info,
                    type: 'line'
                }]
            /* title : {
                x:'center',//x轴方向对齐方式
            },
            toolbox: {
                    show: true,
                    feature: {
                        mark: {show: true},
                        dataView: {show: true, readOnly: false},
                        restore: {show: true},
                        saveAsImage: {show: true}
                    }
                },
            series : [
                {
                    name: '数据分类',
                    type: 'pie',
                    radius : [40, 80],
                    center: ['50%', '50%'],
                    data:[
                        {value:190, name:'1'},
                        {value:90, name:'2'},
                        {value:190, name:'3'},
                        {value:290, name:'4'},
                        {value:70, name:'5'},
                        {value:50, name:'6'},
                        {value:80, name:'7'},
                        {value:10, name:'8'},
                        {value:20, name:'9'},
                    ],
                    roseType: 'area',
                    itemStyle: {
                        borderRadius: 8
                    }
                }
            ]*/
        });
      }
    },
    destroyed() {
      clearInterval(this.timers);
    }
  }
</script>

<style scoped="scoped">
  @keyframes seamless-scrolling {
    0% {
      transform: translateY(0px);
    }
    100% {
      transform: translateY(-51%);
    }
  }

  .fiveLeft{
    float: left;
    width: 33.85%;
    overflow: hidden;
    margin-top: 20px;
  }
  .minbox{
    background: url(../../static/minBoxBg.png) no-repeat;
    background-size: 100% 100%;
    width: 48.5%;
    float: left;
    margin-left: 1%;
    height: 224px;
    margin-bottom: 13px;
  }
  .minbox p{
    margin-top: 72px;
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
  }
  .minbox  span{
    font-size: 60px;
    font-family: Source Han Sans CN;
    font-weight: 500;
  }
  .minbox:nth-child(1) span{
    color: #FAC858;
  }
  .minbox:nth-child(2) span{
    color: #73C0DE;
  }
  .minbox:nth-child(3) span{
    color: #9FE080;
  }
  .minbox:nth-child(4) span{
    color: #992CFF;
  }
  .minbox:nth-child(5) span{
    color: #1F60C4;
  }
  .minbox:nth-child(6) span{
    color: #EE6666;
  }
  .minbox:nth-child(7) span{
    color: #FC8452;
  }
  .minbox:nth-child(8) span{
    color: #04CA96;
  }
  .box{
    width: 32%;
    margin-left: 1%;
    height: 457px;
    background: url(../../static/shortBg.png) no-repeat;
    background-size: 100% 100%;
    float: left;
    margin-top: 20px;
  }
  .alltitle{
    margin-top: 12px;
    margin-left: 20px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    text-align: left;
   
  }
  .echartLine {
    width: 98%;
    height: 400px;
  }
  #pieChart{
    width: 98%;
    height: 460px;
  }
.table1 th{background-color: #02162e; border-bottom: 1px solid #407abd; font-size: 14px; text-align: center; padding: 6px 0; color: rgba(255,255,255,.8)}
.table1 td{ border-bottom: 1px dotted#407abd;font-size: 17px; padding:6px 0;text-align: center; color: rgba(255,255,255,.8)}
.table1 tr:last-child td{border: none;}

</style>



// WEBPACK FOOTER //
// src/components/five.vue